var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descriptionOfPack"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.ReportsDetail.PACKING_INFORMATION'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Batch_1')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.cartonseal,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Batch_2')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.frontmark,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Batch_3')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.sidemark,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Batch_4')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.cartonbarcode,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Batch_5')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.cartonsize,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Batch_6')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.cartonweight,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Batch_7')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.innerpack,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Batch_8')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.cartonlayer,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Batch_9')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.innerbox,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Accessory_Manual_Polybag')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.other,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-table"},[_c('a-table',{staticClass:"desOfGoods-table1",attrs:{"columns":_vm.columns,"dataSource":_vm.details,"bordered":"","pagination":false,"rowKey":"id"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }